import { defer } from 'rxjs';
import { UserApi } from '~/api/user';

export interface Role {
  id: number;
  name: string;
  description: string;
}

export interface User {
  id: number;
  principal: string;
  fullName: string;
  password: string;
  loginCount: number;
  lastLogin: string;
  passwordChanged: string;
  locked: boolean;
  tmpPassword: boolean;
  use2Factor: boolean;
  roles: Array<Role>;
}

export const EmptyUser: User = {
  id: 0,
  principal: '',
  fullName: '',
  password: '',
  loginCount: 0,
  lastLogin: '',
  passwordChanged: '',
  locked: false,
  tmpPassword: false,
  use2Factor: false,
  roles: [],
};

class UserServiceClass {
  getAll() {
    return defer(UserApi.getAll);
  }

  getRoles() {
    return defer(UserApi.getAllRoles);
  }

  get(id: number) {
    return defer(() => UserApi.get(id));
  }

  save(user: User) {
    return defer(() => UserApi.save(user));
  }

  resetPassword(user: User) {
    return defer(() => UserApi.resetPassword(user.id));
  }

  delete(user: User) {
    return defer(() => UserApi.deleteById(user.id));
  }
}

export const UserService = new UserServiceClass();
